<template>
  <div>
    <BaseFrame
      @save="saveValidate"
      @clear="handleReset"
      :save-loading="saveLoading"
      :showCtrls="true"
      save-text="保存"
    >
      <div slot="content">
        <lk-form
          :model="planForm"
          label-position="right"
          :label-width="140"
          :rules="planRules"
          ref="planForm"
        >
          <lk-card title="盘点计划信息" class="mb16">
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="盘点计划名称:" prop="name">
                  <lk-input clearable v-model.trim="planForm.name" :maxlength="50"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="盘点类型:" prop="operatorType">
                  <lk-select clearable v-model.trim="planForm.operatorType" @on-change="operatorTypeSelect">
                    <lk-option v-for="item in checkList" :key="item.id" :value="item.id">
                      {{item.type}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="盘点时间:" prop="operatorTimeStr">
                  <lk-date-picker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    placeholder="请选择"
                    v-model="planForm.operatorTimeStr"
                    :options="validTimeOptions"
                    :time-picker-options="{ steps: [1, 15]}"
                  >
                  </lk-date-picker>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="盘点方式:" prop="operatorPattern">
                  <lk-select clearable v-model.trim="planForm.operatorPattern">
                    <lk-option v-for="item in checkPatterns" :key="item.id" :value="item.id">
                      {{item.pattern}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-card>

           <!-- 总部月盘 -->
           <lk-card title="详细信息" class="mb16" v-if="planForm.operatorType === 1">
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="盘点仓库:">
                  <lk-input disabled value="全部仓库" ></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="是否含0在库数量商品:">
                  <lk-select v-model.trim="planForm.hasZero">
                    <lk-option v-for="item in hasZeros" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="盘点商品:">
                  <lk-input disabled value="全部商品"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col>
                  <lk-form-item label="盘点门店:" prop="authStoreIdList">
                  <lk-select
                    multiple
                    filterable
                    style="min-width:150px"
                    v-model.trim="planForm.authStoreIdList"
                    @on-change="isAllSelectStore"
                  >
                    <lk-option v-for="item in listStores" :key="item.id" :value="item.id" :disabled="allSelectStore">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-card>

          <!-- 总部周盘 -->
          <lk-card title="详细信息" class="mb16" v-else-if="planForm.operatorType === 2">
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="盘点仓库:">
                  <lk-input disabled value="全部商品"></lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="是否含0在库数量商品:">
                  <lk-select v-model.trim="planForm.hasZero" disabled>
                    <lk-option v-for="item in hasZeros" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="10">
                <lk-form-item label="盘点商品:" prop="goodsSalePrice">
                  <lk-checkbox-group v-model="checkboxList">
                      <lk-checkbox label="goodsSalePrice" disabled >
                    商品售价 ≥ </lk-checkbox>
                      <lk-input class="width60" v-model.trim="planForm.goodsSalePrice" :value="planForm.goodsSalePrice" :maxlength="50"></lk-input> 元
                  </lk-checkbox-group>
                </lk-form-item>
                <lk-form-item prop="goodsExpiryDays">
                  <lk-checkbox-group v-model="checkboxList">
                    <lk-checkbox label="goodsExpiryDays">
                  商品近效期 ≤ <lk-input class="width60" v-model.trim="planForm.goodsExpiryDays" :maxlength="50"></lk-input> 天
                  </lk-checkbox>
                  </lk-checkbox-group>
                </lk-form-item>
                <lk-form-item prop="goodsNoSaleRecDays">
                  <lk-checkbox-group v-model="checkboxList">
                    <lk-checkbox label="goodsNoSaleRecDays">
                  商品在近 <lk-input class="width60" v-model.trim="planForm.goodsNoSaleRecDays" :maxlength="50"></lk-input> 天内没有销售记录
                  </lk-checkbox>
                  </lk-checkbox-group>
                </lk-form-item>
                <lk-form-item prop="goodsSaleRecDays">
                  <lk-checkbox-group v-model="checkboxList">
                    <lk-checkbox label="goodsSaleRecDays">
                  商品在近 <lk-input class="width60" v-model.trim="planForm.goodsSaleRecDays" :maxlength="50"></lk-input> 天内有销售记录
                  </lk-checkbox>
                </lk-checkbox-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col>
                <div class="left100">以上选项选择后会将各个门店符合对应条件的商品加入周盘盘点表中。（满足任意条件就会加入）</div>
                <div class="left100 bottom16">如果某个门店库存总数大于0商品少于10个，则该门店盘点表无视条件默认全盘。</div>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="20">
                  <lk-form-item label="盘点门店:" prop="authStoreIdList">
                  <lk-select
                    multiple
                    filterable
                    style="min-width:150px"
                    v-model.trim="planForm.authStoreIdList"
                    @on-change="isAllSelectStore"
                  >
                    <lk-option v-for="item in listStores" :key="item.id" :value="item.id" :disabled="allSelectStore">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-card>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="resetConfirmVisiable"
      @confirm="confirmReset"
      content="重置将取消当前所做更改"
    >
    </DTPModal>
  </div>
</template>
<script>
import utils from '@/libs/utils';
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import inventory from '../../../services/inventory';
import tools from '../../../services/tools';
import system from '../../../services/system';
import DTPModal from '../../../components/DTPModal.vue';


export default {
  components: {
    BaseFrame,
    DTPModal,
  },
  data() {
    return {
      defaultList: ['goodsSalePrice', 'goodsExpiryDays', 'goodsNoSaleRecDays', 'goodsSaleRecDays'],
      checkboxList: ['goodsSalePrice'],
      resetConfirmVisiable: false,
      saveLoading: false,
      hasZeros: [
        {
          id: 1,
          name: '是',
        },
        {
          id: 2,
          name: '否',
        },
      ],
      allSelectStore: false,
      listStores: [],
      checkPatterns: [],
      checkList: [],
      validTimeOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      planForm: {
        hasZero: 2,
        goodsSalePrice: '800',
        goodsExpiryDays: '180',
        goodsNoSaleRecDays: '180',
        goodsSaleRecDays: '7',
        goodsCondition: '',
      },
      planRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
          {
            validator: this.nameExistValidator,
            trigger: 'blur',
          },
        ],
        hasZero: [
          {
            required: true,
            message: '请选择是否包含0库存商品',
            trigger: 'change',
            type: 'number',
          },
        ],
        operatorType: [
          {
            required: true,
            message: '请选盘点类型',
            trigger: 'change',
            type: 'number',
          },
        ],
        operatorPattern: [
          {
            required: true,
            message: '请选盘点方式',
            trigger: 'change',
            type: 'number',
          },
        ],
        operatorTimeStr: [
          {
            required: true,
            message: '请选盘点时间',
            trigger: 'change',
            type: 'date',
          },
        ],
        authStoreIdList: [
          {
            required: true,
            message: '请选盘点门店',
            trigger: 'change',
            type: 'array',
          },
        ],
        goodsSalePrice: [
          {
            required: true,
            message: '请填写商品售价',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsExpiryDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsNoSaleRecDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsSaleRecDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
      }
    }
  },
  computed: {
    isShowWarningWord() { // 只有在盘点方式选择暗盘，盘点类型选择总部月盘或者总部周盘的时候显示提示语
      const patternList = [2]; // 盘点方式暗盘的id值
      const typeList = [1, 2]; // 盘点类型中总部月盘，总部周盘的id值
      if (patternList.includes(this.planForm.operatorPattern) && typeList.includes(this.planForm.operatorType)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    planSaveNotice(fun) {
      this.$Modal.confirm({
        title: '提示',
        content: `<div>提交后将为所选门店批量创建盘点任务,是否确认提交?</div>
                  <div style="color:red;">${this.isShowWarningWord ? '批量创建暗盘盘点有可能影响门店业务，请确保盘点时间和盘点门店选择正确' : ''}</div>
                 `,
        onOk: fun
      })
    },
    saveValidate() {
      return new Promise((resolve) => {
        this.$refs.planForm.validate(valid => {
          if (valid) {
            let now = Date.now();
            const selectTime = new Date(this.planForm.operatorTimeStr).getTime();
            if (now > selectTime) {
              this.$Message.error('盘点时间需大于当前时间');
              return
            }
            this.planForm.operatorTime = selectTime;
            this.planSaveNotice(this.toSave)
          }
        })
      })
    },
    toSave() {
      if (this.planForm.operatorType == 2) { // 总部周盘
        const tempCondition = {};
        let tempHaveDot = false;
        this.checkboxList.forEach((key) => {
          tempCondition[key] = this.planForm[key];
          if (!tempHaveDot) {
            tempHaveDot = this.planForm[key].includes('.');
          }
        });
        if (tempHaveDot) {
          this.$Message.error('多少天中不能包含 小数点');
          return;
        }
        this.planForm.goodsCondition = JSON.stringify(tempCondition);
      }
      this.clearDefaultData();
      tools.batchCreatePlan(this.planForm).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('创建成功');
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handleReset() {
      this.resetConfirmVisiable = true;
    },
    confirmReset() {
      this.$refs.planForm.resetFields();
      this.resetConfirmVisiable = false;
    },
    nameExistValidator(rule, value, callback) {
      this.$store.commit('setDisableLoading', true);
      inventory.isStocktakingPlanNameExist({ name: value }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data) {
            callback(new Error('盘点名称已存在'));
          } else {
            callback();
          }
        } else {
          this.$Message.error(res.data.error);
          callback();
        }
      }).catch((err) => {
        utils.handleError(err);
        callback();
      });
    },
    getOperatorRuleData() {
      inventory.getOperatorRules().then((res) => {
        if (res.data.status === 200) {
          this.checkList = res.data.data.type || [];
          this.checkPatterns = res.data.data.pattern || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        // eslint-disable-next-line no-undef
        utils.handleError(err);
      });
    },
    isAllSelectStore(val) {
      if (val.includes(2)) {
        this.allSelectStore = true;
        val.splice(0, val.length);
        val.push(2);
      }
      if (val.length === 0) {
        this.allSelectStore = false;
      }
    },
    getStoreInfos() {
      system.listStoresEnable().then((res) => {
        if (res.data.status === 200) {
          this.listStores = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    operatorTypeSelect(value) {
      if (value == 2) { // 总部周盘
        this.planForm.hasZero = 2;
        this.planForm.goodsSalePrice = '800';
        this.planForm.goodsExpiryDays = '180';
        this.planForm.goodsNoSaleRecDays = '180';
        this.planForm.goodsSaleRecDays = '7';
      } else {
        // 清空数据
        this.planForm.goodsCondition = '';
        this.clearDefaultData();
      }
    },
    clearDefaultData() {
      this.defaultList.forEach((key) => {
        this.$delete(this.planForm, key);
      });
    },
  },
  created() {
    this.getOperatorRuleData();
    this.getStoreInfos();
  }
}
</script>
<style lang="less" scoped>
.width60 {
  width: 60px;
}
.left100 {
  margin-left: 139px !important;
}
.bottom16 {
  margin-bottom: 16px !important;
}
</style>
